<template>
  <div>
    <div id="container">
      <div id="title-with-description-container">
        <h1 id="title">
          AMERICAN BUSINESSES<br/>
          ARE IN DANGER
        </h1>
        <p id="description">
          Businesses - small, medium and large - have been the strong foundation of
          America from the very beginning. But now, due to the unimaginable effects of the
          global COVID-19 pandemic, these businesses need help. They need support from
          our communities, and, most importantly, our government.
        </p>
      </div>
      <div id="image-container">
        <img src="../assets/header-map.png">
      </div>
      <div class="counters-container">
        <div>
          <h5 class="counter-title">BUSINESSES IN DANGER</h5>
          <number class="counter" :from="1" :to="bizCount" :format="formatCounter" :duration="2" easing="Power0.easeNone"/>
        </div>
        <div>
          <h5 class="counter-title">JOBS AT RISK</h5>
          <number class="counter" :from="1" :to="jobsCount" :format="formatCounter" :duration="2" easing="Power0.easeNone"/>
        </div>
        <div>
          <h5 class="counter-title">YEARS IN BUSINESS</h5>
          <number class="counter" :from="1" :to="yearsCount" :format="formatCounter" :duration="2" easing="Power0.easeNone"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AppHeader',
    data() {
      return {
        bizCount: 1,
        jobsCount: 1,
        yearsCount: 1,
      }
    },
    mounted() {
      this.$root.$on('countsUpdated', data => {
        this.bizCount = data.bizCount
        this.jobsCount = data.jobsCount
        this.yearsCount = data.yearsCount
      })
    },
    methods: {
      formatCounter(number) {
        return number.toLocaleString(undefined, {maximumFractionDigits: 0})
      }
    }
  }
</script>

<style scoped>
  @import "../fonts.css";

  #container {
    margin: 0 auto;
    padding-top: 80px;
    width: 85%;
    max-width: 1216px;
    position: relative;
  }
  #title-with-description-container {
    text-align: left;
  }
  #title {
    font-family: Futura, openSans, serif;
    font-weight: bold;
    font-size: 3.8vw;
    display: inline-block;
    color: black;
  }
  #description {
    font-family: "Avenir Next", openSans, serif;
    font-weight: 500;
    font-size: 1.4vw;
    margin-top: 25px;
    text-align: left;
    width: 62%;
  }
  #image-container {
    position: absolute;
    width: 28%;
    top: 80px;
    right: 0;
  }
  img {
    display: block;
    width: 100%;
    height: auto;
  }
  .counters-container {
    margin-top: 50px;
    display: table;
    width: 100%;
    table-layout: fixed;
    margin-bottom: 20px;
  }
  .counters-container div {
    display: table-cell;
    text-align: center;
  }
  .counter-title {
    font-family: Futura, openSans, serif;
    font-weight: bold;
    font-size: 1.4vw;
  }
  .counter {
    font-family: "Avenir Next", openSans, serif;
    font-weight: bold;
    font-size: 3.5vw;
    display: inline-block;
    color: #CE6363;
    margin-top: 10px;
  }

  /*LARGE DESKTOPS*/
  @media only screen and (min-width: 1440px) {
    #title {
      font-size: 55px;
    }
    #description {
      font-size: 20px;
    }
    .counter-title {
      font-size: 20px;
    }
    .counter {
      font-size: 50px;
      margin-top: 25px;
    }
  }

  /*MOBILE*/
  @media only screen and (max-width: 768px) {
    #container {
      padding-top: 25px;
      width: 93%;
    }
    #title {
      font-size: 6.6vw;
    }
    #description {
      margin-top: 15px;
      font-size: 13px;
      width: 95%;
    }
    #image-container {
      position: static;
      width: 60%;
      margin: 15px auto 0 auto;
    }
    .counters-container {
      margin-top: 30px;
    }
    .counter-title {
      font-size: 2.1vw;
    }
    .counter {
      font-size: 5.9vw;
      margin-top: -5px;
    }
  }
</style>
